import {
    LOCATION_LIST_REQUEST, LOCATION_LIST_SUCCESS, LOCATION_LIST_FAIL,
    LOCATION_LIST_BY_IDS_REQUEST, LOCATION_LIST_BY_IDS_SUCCESS, LOCATION_LIST_BY_IDS_FAIL,
    LOCATION_DETAILS_REQUEST, LOCATION_DETAILS_SUCCESS, LOCATION_DETAILS_FAIL,
    LOCATION_CREATE_REQUEST, LOCATION_CREATE_SUCCESS, LOCATION_CREATE_FAIL,
    LOCATION_UPDATE_REQUEST, LOCATION_UPDATE_SUCCESS, LOCATION_UPDATE_FAIL,
    LOCATION_DELETE_REQUEST, LOCATION_DELETE_SUCCESS, LOCATION_DELETE_FAIL,
    LOCATION_DTO_REQUEST, LOCATION_DTO_SUCCESS, LOCATION_DTO_FAIL,
    LOCATION_BY_ORGANISATION_REQUEST, LOCATION_BY_ORGANISATION_SUCCESS, LOCATION_BY_ORGANISATION_FAIL,
    LOCATION_BY_STATUS_REQUEST, LOCATION_BY_STATUS_SUCCESS, LOCATION_BY_STATUS_FAIL,
    LOCATION_BY_ODS_CODE_REQUEST, LOCATION_BY_ODS_CODE_SUCCESS, LOCATION_BY_ODS_CODE_FAIL,
    LOCATION_BY_LOCATION_CODE_REQUEST, LOCATION_BY_LOCATION_CODE_SUCCESS, LOCATION_BY_LOCATION_CODE_FAIL,
    LOCATION_BY_UPLOAD_BATCH_REQUEST, LOCATION_BY_UPLOAD_BATCH_SUCCESS, LOCATION_BY_UPLOAD_BATCH_FAIL,
    LOCATION_SUBJECTS_REQUEST, LOCATION_SUBJECTS_SUCCESS, LOCATION_SUBJECTS_FAIL,
} from '../constants/locationConstants';

export const locationListReducer = (state = { locations: [] }, action) => {
    switch (action.type) {
        case LOCATION_LIST_REQUEST:
            return { loading: true, locations: [] };
        case LOCATION_LIST_SUCCESS:
            return {
                loading: false,
                locations: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case LOCATION_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationListByIdsReducer = (state = { locations: [] }, action) => {
    switch (action.type) {
        case LOCATION_LIST_BY_IDS_REQUEST:
            return { loading: true, locations: [] };
        case LOCATION_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                locations: action.payload,
            };
        case LOCATION_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationDetailsReducer = (state = { location: {} }, action) => {
    switch (action.type) {
        case LOCATION_DETAILS_REQUEST:
            return { loading: true, location: {} };
        case LOCATION_DETAILS_SUCCESS:
            return { loading: false, location: action.payload };
        case LOCATION_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case LOCATION_CREATE_REQUEST:
            return { loading: true };
        case LOCATION_CREATE_SUCCESS:
            return { loading: false, success: true, location: action.payload };
        case LOCATION_CREATE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case LOCATION_UPDATE_REQUEST:
            return { loading: true };
        case LOCATION_UPDATE_SUCCESS:
            return { loading: false, success: true, location: action.payload };
        case LOCATION_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case 'LOCATION_UPDATE_RESET':
            return {};
        default:
            return state;
    }
};

export const locationDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case LOCATION_DELETE_REQUEST:
            return { loading: true };
        case LOCATION_DELETE_SUCCESS:
            return { loading: false, success: true };
        case LOCATION_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationDtoReducer = (state = { locationDto: {} }, action) => {
    switch (action.type) {
        case LOCATION_DTO_REQUEST:
            return { loading: true, locationDto: {} };
        case LOCATION_DTO_SUCCESS:
            return { loading: false, locationDto: action.payload };
        case LOCATION_DTO_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Custom location-specific reducers
export const locationByOrganisationReducer = (state = { locations: [] }, action) => {
    switch (action.type) {
        case LOCATION_BY_ORGANISATION_REQUEST:
            return { loading: true, locations: [] };
        case LOCATION_BY_ORGANISATION_SUCCESS:
            return { loading: false, locations: action.payload };
        case LOCATION_BY_ORGANISATION_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationByStatusReducer = (state = { locations: [] }, action) => {
    switch (action.type) {
        case LOCATION_BY_STATUS_REQUEST:
            return { loading: true, locations: [] };
        case LOCATION_BY_STATUS_SUCCESS:
            return { loading: false, locations: action.payload };
        case LOCATION_BY_STATUS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationByODSCodeReducer = (state = { location: {} }, action) => {
    switch (action.type) {
        case LOCATION_BY_ODS_CODE_REQUEST:
            return { loading: true, location: {} };
        case LOCATION_BY_ODS_CODE_SUCCESS:
            return { loading: false, location: action.payload };
        case LOCATION_BY_ODS_CODE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationByLocationCodeReducer = (state = { location: {} }, action) => {
    switch (action.type) {
        case LOCATION_BY_LOCATION_CODE_REQUEST:
            return { loading: true, location: {} };
        case LOCATION_BY_LOCATION_CODE_SUCCESS:
            return { loading: false, location: action.payload };
        case LOCATION_BY_LOCATION_CODE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const locationUploadBatchReducer = (state = {}, action) => {
    switch (action.type) {
        case LOCATION_BY_UPLOAD_BATCH_REQUEST:
            return { loading: true };
        case LOCATION_BY_UPLOAD_BATCH_SUCCESS:
            return { 
                loading: false, 
                success: true, 
                locations: action.payload.items || [],
                totalCount: action.payload.totalCount || 0,
                currentPage: action.payload.currentPage || 1,
                totalPages: action.payload.totalPages || 1
            };
        case LOCATION_BY_UPLOAD_BATCH_FAIL:
            return { loading: false, error: action.payload };
        case LOCATION_UPDATE_SUCCESS:
            // Update the specific location in the list without API call
            if (state.locations && action.payload) {
                const updatedLocations = state.locations.map(location => 
                    location.id === action.payload.id ? action.payload : location
                );
                return {
                    ...state,
                    locations: updatedLocations
                };
            }
            return state;
        default:
            return state;
    }
};

export const locationSubjectsReducer = (state = { subjects: [] }, action) => {
    switch (action.type) {
        case LOCATION_SUBJECTS_REQUEST:
            return { loading: true, subjects: [] };
        case LOCATION_SUBJECTS_SUCCESS:
            return {
                loading: false,
                subjects: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
                limit: action.payload.limit,
            };
        case LOCATION_SUBJECTS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}; 